import { xmlUrlString } from '../../../../api/helpers'

const iniMarkerDisplayState = (images, krpanoVrModeObj, objectId) => {
  images.forEach((img, index) => {
    krpanoVrModeObj.vrModeShouldShow.push(
      `markerInfoImage_${index}_${objectId}`
    )
  })
  krpanoVrModeObj.vrModeShouldShow.push(`markerNext_${objectId}`)
  krpanoVrModeObj.vrModeShouldShow.push(`markerPrev_${objectId}`)
  krpanoVrModeObj.vrModeShouldShow.push(`markerScaleUp_${objectId}`)
  krpanoVrModeObj.vrModeShouldShow.push(`markerScaleDown_${objectId}`)
}
const returnIniMarkerXml = (
  images,
  objectId,
  handleReopenMarker
) => {
  let xml = ''
  xml += images
    .map(
      (img, index) => `<hotspot
        name="markerInfoImage_${index}_${objectId}"
        style="markerInfoGalleryImage_${objectId}"
        url="${xmlUrlString(img)}"
        scale="0"
        zorder="999"
        visible="true"
        width="500"
        height="500"
        enabled="false" />`
    )
    .join(' ')

  xml += `
    <hotspot
      name="markerNext_${objectId}"
      style="markerButton"
      url="${require('../img/button/right-default.png')}"
      zorder="999"
      scale="0"
      edge="lefttop"
      onover="${handleReopenMarker} next_onover(markerNext_${objectId});"
      onout="next_onout(markerNext_${objectId});"
      onclick="next_onclick(${objectId});" />
    <hotspot
      name="markerPrev_${objectId}"
      style="markerButton"
      url="${require('../img/button/left-disable.png')}"
      zorder="999"
      scale="0"
      edge="lefttop"
      onover="${handleReopenMarker} prev_onover(markerPrev_${objectId});"
      onout="prev_onout(markerPrev_${objectId});"
      onclick="prev_onclick(${objectId});" />
      `

  xml += `
    <hotspot
      name="markerScaleUp_${objectId}"
      style="markerButton"
      url="${require('../img/button/plus-default.png')}"
      zorder="999"
      scale="0"
      edge="lefttop"
      onover="${handleReopenMarker} scaleUp_onover(markerScaleUp_${objectId});"
      onout="scaleUp_onout(markerScaleUp_${objectId});"
      onclick="scale_up_onclick(${objectId});" />
    <hotspot
      name="markerScaleDown_${objectId}"
      style="markerButton"
      url="${require('../img/button/minus-default.png')}"
      zorder="999"
      scale="0"
      edge="lefttop"
      onover="${handleReopenMarker} scaleDown_onover(markerScaleDown_${objectId});"
      onout="scaleDown_onout(markerScaleDown_${objectId});"
      onclick="scale_down_onclick(${objectId});" />
      `
  return xml
}

export const componentGalleryXml = (
  marker,
  krpanoVrModeObj,
  handleReopenMarker
) => {
  const images = marker.images
  if (images.length < 1) return ''

  const objectId = marker.objectId

  iniMarkerDisplayState(images, krpanoVrModeObj, objectId)
  const gallery = returnIniMarkerXml(
    images, objectId, handleReopenMarker
  )
  return gallery
}
